module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=EE - Estonia.87494e84.svg";